import { noop } from '../../utils/fn'
import { m, createElementWithCallback } from '../../utils/mithril'
import { toggleBemClass, bem, node } from '../../utils/dom'
import { registerHamburger } from '../../../components/hamburger/hamburger'
import { getPlatform, getIsDesktop, getIsTablet, viewport } from '../../utils/ua'
import {
  mobileHeaderOrientationHandler,
  repositionMobileHeader,
} from '../../../components/header/headerComponents'
import BaseView from './BaseView'

export default class NavbarView extends BaseView {
  view(ctrl) {
    super.view(ctrl)
    return createElementWithCallback('.navbar-shared-component', {
      callback: this.viewRenderCallback(ctrl),
      children: this.getCurrentView(ctrl.vm),
    })
  }

  viewRenderCallback(ctrl) {
    let { vm } = ctrl
    return (element, isInit, context) => {
      if (!isInit) {
        vm.registerScrollingActions()
        this.registerHamburgerActions()
        mobileHeaderOrientationHandler(vm)
      }
    }
  }

  getCurrentView(vm) {
    let { stickyEnabledView, stickyDisabledView } = this
    let currentViewMethod = vm.store.isStickyEnabled ? stickyEnabledView : stickyDisabledView
    let headerMainActions = function getHeaderActionsBemClassName(hidden) {
      return `${bem('header-container')('header-main-actions', { hidden })}`
    }

    if (vm.store.isStickyEnabled && getIsTablet() && !viewport.isPortrait) {
      toggleBemClass(headerMainActions(false).split(' ').pop(), headerMainActions(true))
    } else {
      toggleBemClass(headerMainActions(true).split(' ').pop(), headerMainActions(false))
    }
    repositionMobileHeader(vm)
    return currentViewMethod.apply(this, [vm])
  }

  stickyEnabledView(vm) {
    return noop
  }

  stickyDisabledView(vm) {
    return noop
  }

  registerHamburgerActions() {
    return registerHamburger()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/NavbarView.js